import { styled } from '@linaria/react';
import { colors, fonts } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, min-content);
  gap: 3px;
  align-items: center;
`;

export const PriceLabel = styled.span<{ $size: 'small' | 'medium' | 'large' }>`
  font-family: ${fonts.body};
  font-size: ${(p) =>
    p.$size === 'large' ? '1.625rem' : p.$size === 'medium' ? '1.25rem' : '0.9rem'};
  color: ${colors.fontSecondary};
`;

export const PriceAmount = styled.span<{ $size: 'small' | 'medium' | 'large' }>`
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.bold};
  color: ${colors.fontPrimary};
  font-size: ${(p) =>
    p.$size === 'large' ? '1.625rem' : p.$size === 'medium' ? '1.25rem' : '0.9rem'};
`;

export const DiscountRow = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 0.4rem;
`;

export const OriginalPrice = styled.span<{ $size: 'small' | 'medium' | 'large' }>`
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.bold};
  color: ${colors.grey};
  text-decoration: line-through;
  font-size: ${(p) =>
    p.$size === 'large' ? '1.625rem' : p.$size === 'medium' ? '1.25rem' : '0.9rem'};
`;

export const DiscountedPrice = styled.span<{ $size: 'small' | 'medium' | 'large' }>`
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.bold};
  color: ${colors.fontPrimary};
  font-size: ${(p) =>
    p.$size === 'large' ? '1.625rem' : p.$size === 'medium' ? '1.25rem' : '0.9rem'};
`;
